module.exports = __webpack_public_path__ + "static/vr-3-2-f0b5458663c24bd9661047235e5e206f.jpeg";